import React from 'react'
const ContenedorPrincipal = (props) => {
    return <div className={`p-grid  ${props.extra ? props.extra : ""} `}>
        {props.children}
    </div>
}
export default ContenedorPrincipal;
